var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.dismissedStaticFeedback
    ? _c(
        "a",
        {
          staticClass: "p-2",
          attrs: { id: "sticky-feedback", href: _vm.href, target: "_blank" },
        },
        [
          _c(
            "button",
            {
              staticClass: "border-0 p-0 bg-transparent",
              attrs: { id: "sticky-feedback__close" },
              on: { click: _vm.dismiss },
            },
            [_c("svg-close-circle")],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "mt-5 mb-2",
              attrs: { id: "sticky-feedback__label" },
            },
            [_vm._v(_vm._s(_vm.i18n.helpUsImprove))]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { id: "sticky-feedback__icon-heart" } },
            [_c("svg-icon-heart")],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }